import UIElement from "@adyen/adyen-web/dist/types/components/UIElement";
import Core from "@adyen/adyen-web/dist/types/core";
import { getAdyenShopperLocale, PublicConfigurationT } from "@swo/shared";
import { useEffect, useState } from "react";
import { usePageContext } from "../../../../../global/page-context";
import { useStore } from "../../../../../store/hooks/use-store";
import { createAdyenCheckout } from "./adyen";
import type { CoreOptions } from "@adyen/adyen-web/dist/types/core/types";

export type InternalAdyenConfig = {
  locale: string;
  paymentMethodsResponse: (r: any) => void;
  onChange: (state: unknown, component: UIElement) => void;
  onAdditionalDetails: (state: unknown, component: UIElement) => void;
  analytics: CoreOptions["analytics"];
  adyenConfig: PublicConfigurationT["adyen"];
};

export function useConfiguredAdyenInstance(
  handleOnAdditionalDetails: (state: unknown, component: UIElement) => void,
  handleOnChange: (state: unknown, component: unknown) => void,
) {
  const storeState = useStore();
  const ctx = usePageContext();

  return useAdyenInstance({
    adyenConfig: storeState.state.config.adyen,
    languageIsoCode: ctx.pageBase.locale.language.isoCode,
    handleOnAdditionalDetails,
    handleOnChange,
  });
}

function useAdyenInstance(configuration: {
  adyenConfig: PublicConfigurationT["adyen"];
  languageIsoCode: string;
  handleOnAdditionalDetails: (state: unknown, component: UIElement) => void;
  handleOnChange: (state: unknown, component: unknown) => void;
}): AdyenInstance | undefined {
  const config: InternalAdyenConfig = {
    locale: getAdyenShopperLocale(configuration.languageIsoCode),
    adyenConfig: configuration.adyenConfig,
    paymentMethodsResponse: paymentMethodsResponse,
    onChange: configuration.handleOnChange,
    onAdditionalDetails: configuration.handleOnAdditionalDetails,
    analytics:
      configuration.adyenConfig.environment === "test"
        ? {
            enabled: true,
            telemetry: true,
          }
        : undefined,
  };

  const [UNTYPED_adyenInstance, setAdyenInstance] = useState<AdyenInstance | undefined>(undefined);

  function paymentMethodsResponse(response: any) {
    // console.log(response);
  }

  useEffect(() => {
    void createAdyenCheckout(config).then(instance => {
      setAdyenInstance({ underlying: instance, tag: "adyen-instance" });
    });
  }, []);

  return UNTYPED_adyenInstance;
}

export type AdyenInstance = { underlying: Core; tag: "adyen-instance" };
